export default {
  methods: {
    notifyError(message, interpolations) {
      this.$store.dispatch('notify', { type: 'error', message: this.$mpt(this.$t(message, interpolations)) });
    },
    notifySuccess(message, interpolations) {
      this.$store.dispatch('notify', { type: 'success', message: this.$mpt(this.$t(message, interpolations)) });
    },
    notifyWarning(message, interpolations) {
      this.$store.dispatch('notify', { type: 'warning', message: this.$mpt(this.$t(message, interpolations)) });
    },
  },
};
